<script setup>
import { watch} from 'vue';

const props = defineProps([
  'daySlots',
  'selectedDay',
  'selectedHour',
  'selectedNumberOfReservations',
  'id',
  'name',
  'isValid'
]);
defineEmits(["change"]);

watch(() => {
  const hours = props.daySlots?.find(
    (slot) => slot.date === props.selectedDay
  )?.slots || [];

  if(hours.length > 0) {
    let elementToScrollId = 'wrapHours0';

    for (var i = 0; i < hours.length; i++) {
      if (hours[i]?.slotStatus === 'AVAILABLE') {
        elementToScrollId = 'wrapHours' + i;
        break;
      }
    }

    setTimeout(() => {
      scrollToItem(elementToScrollId);
    }, 250);
  }
});

// Calcola la posizione dell'elemento e scrolla il contenitore
function scrollToItem(itemId) {
  const container = document.getElementById('hoursList');
  const targetElement = document.getElementById(itemId);
  container.scrollTop = targetElement.offsetTop;
}

</script>
<style scoped>
#hoursList {
  position: relative;
}
@media screen and (min-width: 992px) {
  #hoursList {
    height: 420px;
    overflow-y: auto;
  }
}
</style>
<template>
<div :id="`${props.id}`">
  <div aria-live="polite" class="visually-hidden">
    <label for="hoursList" tabindex="0">Elenco degli orari prenotabili nel giorno {{ (new Date(selectedDay)).toLocaleString('it-IT', { weekday: 'long', year: "numeric", month: "long", day: "numeric" }) }}</label>
  </div>
  <div class="bg-white p-4" id="hoursList">
    <div
      v-for="(slot, index) in props.daySlots?.find(
        (slot) => slot.date === props.selectedDay
      )?.slots || []"
      :key="slot.startTime"
      :id="`wrapHours${index}`"
    >
      <div class="form-check">
        <input
          :name="`${props.name}`"
          :id="`${props.id}_${index}`"
          type="radio"
          :checked="props.selectedHour === slot.startTime"
          :value="slot.startTime"
          :disabled="
            slot.slotStatus !== 'AVAILABLE' ||
            props.selectedNumberOfReservations > slot.reservationsAvailable
          "
          :aria-label="`Orario ${slot.startTime} - Posti disponibili (${slot.reservationsAvailable})`"
          data-yup-label="Orario"
          :data-yup-error-id-label="`hoursList`"
          :data-yup-error-id-field="`hoursList`"
          @change="
            () => {
              $emit('change', {
                startTime: slot.startTime,
                endTime: slot.endTime,
                slotDate: props.selectedDay,
              });
            }
          "
        />
        <label
          :for="`${props.id}_${index}`"
          :class="`${
            slot.slotStatus !== 'AVAILABLE' ||
            selectedNumberOfReservations > slot.reservationsAvailable
              ? 'text-muted'
              : ''
          }`"
        >
          {{ slot.startTime }} ({{ slot.reservationsAvailable }})
          <br
            v-if="
              slot.slotStatus !== 'AVAILABLE' ||
              props.selectedNumberOfReservations > slot.reservationsAvailable
            "
          />
          <small
            class="text-muted"
            v-if="
              slot.slotStatus !== 'AVAILABLE' ||
              props.selectedNumberOfReservations > slot.reservationsAvailable
            "
          >Esaurito</small
          >
        </label>
      </div>
      <div
        :class="`border-top mb-2 ${
          slot.slotStatus !== 'AVAILABLE' ||
          props.selectedNumberOfReservations > slot.reservationsAvailable
            ? 'mt-2'
            : ''
        }`"
        style="height: 0.5rem"
      >
        &nbsp;
      </div>
    </div>
  </div>
</div>
</template>
